<template>
  <div class="nav-wrapper">
    <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title">{{ $t('businessGoals.title') }}</h1>

        <div class="experience-options">
          <label class="experience-option" :class="{ 'selected': businessGoals === 'side' }">
            <input type="radio" v-model="businessGoals" value="side" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessGoals.options.side') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessGoals === 'primary' }">
            <input type="radio" v-model="businessGoals" value="primary" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessGoals.options.primary') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessGoals === 'next_big' }">
            <input type="radio" v-model="businessGoals" value="next_big" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessGoals.options.next_big') }}</span>
          </label>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('businessGoals.next') }}</button>
        <button class="skip-button" @click="$emit('skip')">{{ $t('businessGoals.skip') }}</button>
      </div>
    </div>

    <div class="image-section">
      <img src="@/assets/slider5.1.png" alt="Business Goals Checklist" class="main-image">
    </div>
  </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessGoals',
  components: {
    BackButton
  },
  data() {
    return {
      businessGoals: 'side',
    }
  },
  methods: {
    handleNext() {
      this.$emit('next', {
        businessGoals: this.businessGoals
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 